import * as Yup from "yup";

import { AccountType } from "@/modules/Accounts/types";

export const ownershipTransferFieldsSchema = (accountType: AccountType) => {
  const baseSchema = {
    fullName: Yup.string().required("Nome / Razão social é obrigatório"),
    whatsapp: Yup.string().required("WhatsApp é obrigatório"),
    documentNumber: Yup.string().required("Documento é obrigatório"),
    email: Yup.string()
      .required("E-mail é obrigatório")
      .email("E-mail inválido"),
    addresses: Yup.array()
      .of(
        Yup.object({
          zipCode: Yup.string()
            .required("CEP é obrigatório")
            .matches(/^\d{5}-?\d{3}$/, "CEP inválido"),
          city: Yup.string().required("Cidade é obrigatória"),
          state: Yup.string().required("Estado é obrigatório"),
          street: Yup.string().required("Rua é obrigatória"),
          neighborhood: Yup.string().required("Bairro é obrigatório"),
          number: Yup.string().required("Número é obrigatório"),
          note: Yup.string()
        })
      )
      .min(1, "Pelo menos um endereço é obrigatório")
  };

  if (accountType === AccountType.LEGAL) {
    return Yup.object({
      ...baseSchema,
      legalRepresentativeName: Yup.string().required(
        "Nome do representante legal é obrigatório"
      ),
      legalRepresentativeDocument: Yup.string().required(
        "CPF do representante legal é obrigatório"
      )
    });
  }

  if (accountType === AccountType.PHYSICAL) {
    return Yup.object({
      ...baseSchema,
      secondaryDocument: Yup.string().notRequired()
    });
  }

  return Yup.object(baseSchema);
};
